/* global process */
import axios from 'axios'

// 与 alg-admin2/.env 中 VUE_APP_ORDER_AUDIT_API_HOST 对齐；避免运行时未注入 _env_ 时拼出 "undefined/admin/..." 导致列表请求失败
let orderAuditBase = (window._env_ && window._env_.VUE_APP_ORDER_AUDIT_API_HOST) || '//order-audit-api.local.slicejobs.com'

// 复核目标管理 - 列表/新增/修改
export const queryReviewPlanTable = params => {
  return axios.post(`${orderAuditBase}/admin/review_plan/query`, params)
}

export const createReviewPlan = params => {
  return axios.post(`${orderAuditBase}/admin/review_plan/create`, params)
}

export const updateReviewPlan = params => {
  const { id, ...body } = params || {}
  return axios.post(`${orderAuditBase}/admin/review_plan/update_${id}`, body)
}

export const deleteReviewPlan = params => {
  const { id } = params || {}
  return axios.post(`${orderAuditBase}/admin/review_plan/delete_${id}`, {})
}

export const getReviewPlan = params => {
  return axios.get(`${orderAuditBase}/admin/review_plan/get_${params.id}`)
}




// WEBPACK FOOTER //
// ./src/views/task/review-plan.api.js